import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import { YearSelector } from 'site-modules/lease-deals/components/deals-checker-widget/components/deal-form/year-selector';
import { MakeSelector } from 'site-modules/lease-deals/components/deals-checker-widget/components/deal-form/make-selector';
import { ModelSelector } from 'site-modules/lease-deals/components/deals-checker-widget/components/deal-form/model-selector';
import { NumericController } from 'site-modules/lease-deals/components/deals-checker-widget/components/deal-form/numeric-controller';

const LEASE_DETAILS_FIELDS = [
  {
    name: 'msrp',
    labelText: 'MSRP',
    max: 999999,
    adornment: '$',
    validateRules: { required: 'MSRP is required' },
    trackingId: 'deal_checker_input_msrp',
  },
  {
    name: 'monthlyPayment',
    labelText: 'Monthly payment',
    max: 9999,
    adornment: '$',
    validateRules: { required: 'Monthly payment is required' },
    trackingId: 'deal_checker_input_payment',
  },
  {
    name: 'term',
    labelText: 'Term (months)',
    max: 99,
    validateRules: { required: 'Term is required' },
    trackingId: 'deal_checker_input_term',
  },
  {
    name: 'dueAtSigning',
    labelText: 'Due at signing',
    max: 99999,
    adornment: '$',
    trackingId: 'deal_checker_input_due_at_signing',
  },
];

export const DealForm = memo(({ onSubmit }) => {
  const methods = useForm({
    mode: 'onTouched',
    defaultValues: {
      make: '',
      model: '',
      year: '',
      msrp: '',
      monthlyPayment: '',
      term: '',
      dueAtSigning: '',
    },
  });
  const {
    formState: { isValid },
  } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} className="flex-grow-1">
        <h3>Lease deal checker</h3>
        <fieldset className="d-flex flex-column gap-1 mb-1_5">
          <legend className="size-16 text-cool-gray-10 fw-medium mb-1">Vehicle information</legend>
          <YearSelector />
          <MakeSelector />
          <ModelSelector />
        </fieldset>

        <fieldset className="d-flex flex-column gap-1 mb-1">
          <legend className="size-16 text-cool-gray-10 fw-medium mb-1">Lease details</legend>
          {LEASE_DETAILS_FIELDS.map(field => (
            <NumericController key={field.name} {...field} />
          ))}
        </fieldset>

        <button
          type="submit"
          className="btn btn-blue-50 w-100 rounded-pill size-16 text-transform-none fw-medium mt-auto px-1 py-0_5"
          disabled={!isValid}
          data-tracking-id="deal_checker_submit"
        >
          Check your deal
        </button>
      </form>
    </FormProvider>
  );
});

DealForm.displayName = 'DealForm';

DealForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};
